export enum ItemStylesByKeyModes {
  Error = 'error',
  Edited = 'edited',
  Selected = 'selected',
}
